import { __assign } from "tslib";
import React, { createContext, forwardRef, useContext, } from 'react';
export var formFieldContext = createContext(undefined);
export var FormFieldContextProvider = formFieldContext.Provider;
export var useFormFieldContext = function () { return useContext(formFieldContext); };
var ARIA_DESCRIBEDBY = 'aria-describedby';
/**
 * Provide (all?) the input component props & the context, this function
 * will return the properties you should use inside the component, based on
 * props and context.
 */
export function getMergedInputProps(props, ctx) {
    var returnProps = __assign(__assign({}, props), { error: getMergedBooleanPropsLeading(props.error, ctx === null || ctx === void 0 ? void 0 : ctx.error), warning: getMergedBooleanPropsLeading(props.warning, ctx === null || ctx === void 0 ? void 0 : ctx.warning), success: getMergedBooleanPropsLeading(props.success, ctx === null || ctx === void 0 ? void 0 : ctx.success), withFeedbackIcon: getMergedBooleanPropsLeading(props.withFeedbackIcon, ctx === null || ctx === void 0 ? void 0 : ctx.withFeedbackIcon), disabled: getMergedBooleanPropsLeading(props.disabled, ctx === null || ctx === void 0 ? void 0 : ctx.disabled), readOnly: getMergedBooleanPropsLeading(props.readOnly, ctx === null || ctx === void 0 ? void 0 : ctx.readOnly), size: props.size || (ctx === null || ctx === void 0 ? void 0 : ctx.size), required: getMergedBooleanPropsLeading(props.required, ctx === null || ctx === void 0 ? void 0 : ctx.required), id: (ctx === null || ctx === void 0 ? void 0 : ctx.inputId) || props.id });
    if (ctx === null || ctx === void 0 ? void 0 : ctx.ariaDescribedby) {
        returnProps[ARIA_DESCRIBEDBY] =
            [ctx.ariaDescribedby, props[ARIA_DESCRIBEDBY]]
                .filter(Boolean)
                .join(' ') || undefined;
    }
    return returnProps;
}
export function useInputPropsMergedWithFormFieldContext(props) {
    var ctx = useFormFieldContext();
    return getMergedInputProps(props, ctx);
}
/**
 * This function maps our own FormFieldContext to Mui input properties.
 * For now they are equal, but who knows..
 */
export function withFormFieldContextForMui(Component) {
    return forwardRef(function (muiProps, ref) {
        var _a;
        var formFieldCtx = useFormFieldContext();
        /* making you of the useMerge, so mapping is in a single place */
        var _b = getMergedInputProps((_a = {
                error: muiProps.error,
                disabled: muiProps.disabled,
                readOnly: muiProps.readOnly,
                required: muiProps.required,
                id: muiProps.id
            },
            _a[ARIA_DESCRIBEDBY] = muiProps[ARIA_DESCRIBEDBY],
            _a), formFieldCtx), error = _b.error, disabled = _b.disabled, readOnly = _b.readOnly, required = _b.required, id = _b.id, ariaDescribedby = _b["aria-describedby"];
        var passProps = {
            error: error,
            disabled: disabled,
            readOnly: readOnly,
            required: required,
            id: id,
            'aria-describedby': ariaDescribedby,
        };
        return React.createElement(Component, __assign({}, muiProps, passProps, { ref: ref }));
    });
}
function getMergedBooleanPropsLeading(propsValue, contextValue) {
    if (propsValue === undefined && contextValue !== undefined) {
        return contextValue;
    }
    return propsValue;
}
//# sourceMappingURL=FormFieldContext.js.map